import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/goin',
    name: 'goin',
    component: () => import( '../views/GoinView.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import( '../views/ApplicationView.vue')
  },
  {
    path: '/appdetail/:id',
    name: 'appdetail',
    component: () => import( '../views/AppdetailView.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import( '../views/ProductsView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import( '../views/NewsView.vue')
  },
  {
    path: '/newsdetail/:id',
    name: 'newsdetail',
    component: () => import( '../views/NewsDetailView.vue')
  },
  {
    path: '/tech',
    name: 'tech',
    component: () => import( '../views/TechView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import( '../views/Contact.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,

  // ----------------------------------------------
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router